<template>
  <Select
    :items="arrayPerPage"
    :selectedItem="filter.perPage"
    label="Registros por página"
    searchPlaceholder="Buscar quantidade"
    @atualizar="atualizar"
    :filtro_id="filtro.filtro"
    :path="path"
  />
</template>
<script>
import Select from '../../components/Select.vue';
export default {
  components: {
    Select,
  },
  props: {
    filtro: {
      type: Object,
      required: true,
    },
    path: {
      type: String,
      required: true
    }
  },
  data() {
    const buildPerPage = [10,20,50,250,500].map(item=>({
      id: item , name: `${item} registros`
    }))
    return {
      filter: {
        perPage: {
          id: "",
          name: "",
        },
      },
      arrayPerPage: buildPerPage,
    };
  },
  methods: {
    atualizar(perPage) {
      this.filter.perPage = perPage || { id: '', name: '' };

      const valor = this.filter.perPage.id;
      this.$aplicaFiltroEmURL(this.filtro.filtro, valor, this.path);
      this.$store.commit('addFiltro', this.filtro);
      this.$store.commit('addFiltroAplicado', {
        filtro: this.filtro.filtro,
        valor: valor
      });
    },
  },
  mounted() {
    const filtroAplicado = this.$store.state.filtroAplicados[this.filtro.filtro];
    this.$renderFiltroSelect(filtroAplicado, this.arrayPerPage, this.filter.perPage);
  },
}
</script>
